import * as Sentry from "@sentry/browser";

import cookie from "react-cookies";

export const sentrylog = ({ messageType, debuginfo, isError, user }) => {
  if (isError) {
    Sentry.captureException(new Error(`bferror ${messageType}`), (scope) => {
      scope.setUser({ id: user?.id });
      scope.setTag("bfevent", "bug");
      scope.setContext("debuginfo", debuginfo);
      return scope;
    });
  } else {
    Sentry.captureMessage(`bfinfo ${messageType}`, (scope) => {
      scope.setUser({ id: user?.id });
      scope.setTag("bfevent", "info");
      scope.setContext("debuginfo", debuginfo);
      return scope;
    });
  }
};

export const sentryBreadcrumb = (breadcrumb) => {
  Sentry.addBreadcrumb(breadcrumb);
};
